import { ReactNode } from 'react';
import { AgenciesQuery } from '../../graphql/graphql';
import { ResidenceCardProps } from '../Cards/ResidencesCard';

export enum BusinessItemsType {
  agencies = 'agencies',
  residences = 'residences'
}

type Item = ResidenceCardProps | AgenciesQuery['agencies'][number];

export interface BusinessItemsListPageProps {
  setErrorUI: (arg: boolean) => void;
  title: string;
  hasError: boolean;
  items: Item[];
  type?: BusinessItemsType;
  children?: ReactNode;
  loading?: boolean;
  isMapView?: boolean;
  mapView?: React.ReactNode;
}
